module.exports = __webpack_public_path__ + "static/media/shell.e23f6917.md";